/* MAMEIDO Editorial-Stil: Wörter in Überschriften kursiv schalten (siehe snippets/mameido-fonts.liquid)
   Im Theme-Editor ein Wort mit Sternchen umgeben: "Dein *Begleiter* für unterwegs" -> Dein <em>Begleiter</em> für unterwegs.
   Nur Überschriften werden angefasst, und nur dort, wo ein Paar Sternchen um Text ohne Tags steht. Ein einzelnes Sternchen
   (z. B. "59 €*") bleibt, wie es ist. Läuft beim Laden und, wenn der Theme-Editor einen Abschnitt neu zeichnet. */
(function () {
  var SELECTOR = 'h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6,.section-header__title,.hero__title,.hero__top-subtitle,[data-editorial]'
  // Öffnendes * steht am Anfang oder nach Leerzeichen/Klammer/Anführungszeichen und hat direkt Text dahinter; schließendes * hat
  // direkt Text davor und steht vor Leerzeichen, Satzzeichen oder am Ende. So bleibt ein Fußnoten-Sternchen (59 €*) in Ruhe.
  var PAIR = /(^|[\s>(„“"'])\*(\S(?:[^*<>\n]*?\S)?)\*(?=$|[\s<.,;:!?)“”"'’—–-])/g

  function convert(root) {
    var scope = root && root.querySelectorAll ? root : document
    var nodes = scope.querySelectorAll(SELECTOR)
    if (scope !== document && scope.matches && scope.matches(SELECTOR)) nodes = [scope].concat([].slice.call(nodes))
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i]
      if (el.getAttribute('data-mm-ed') === '1') continue
      var html = el.innerHTML
      if (html.indexOf('*') === -1) continue
      var out = html.replace(PAIR, '$1<em class="mm-ed">$2</em>')
      if (out !== html) el.innerHTML = out
      el.setAttribute('data-mm-ed', '1')
    }
  }

  // Überschrift-Farbe (Einstellung "Farbe der Überschriften"): nur dunkle Überschriften bekommen die Klasse mm-hc, helle (weiß auf Bild) nicht.
  // Dunkel = berechnete Farbe mit Helligkeit unter 0,35. Läuft nur, wenn die Einstellung gesetzt ist (Variable --mm-heading-color).
  function markColor(root) {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--mm-heading-color')
    if (!v || !v.trim()) return
    var scope = root && root.querySelectorAll ? root : document
    var nodes = scope.querySelectorAll(SELECTOR)
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i]
      if (el.classList.contains('mm-hc') || el.getAttribute('data-mm-hc') === '1') continue
      var m = getComputedStyle(el).color.match(/[0-9.]+/g)
      if (!m || m.length < 3) continue
      var lum = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255
      el.setAttribute('data-mm-hc', '1')
      if (lum < 0.35) el.classList.add('mm-hc')
    }
  }

  function start() { convert(document); markColor(document) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()

  // Theme-Editor: neu gezeichnete Abschnitte und geänderte Einstellungen
  document.addEventListener('shopify:section:load', function (e) { convert(e.target); markColor(e.target) })
  document.addEventListener('shopify:section:reorder', start)
})()
